import ReconciliationActs from "../components/ReconciliationActs/ReconciliationActs";
import ReconciliationAct from "../components/ReconciliationActs/ReconciliationAct";

const reconciliationActs = [
  {
    path: '/reconciliation_acts',
    name: 'ReconciliationActs',
    component: ReconciliationActs,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true,
  },
  {
    path: '/reconciliation_acts/new',
    name: 'ReconciliationActAdd',
    component: ReconciliationAct,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true
  },
  {
    path: '/reconciliation_acts/edit/:id',
    name: 'ReconciliationActEdit',
    component: ReconciliationAct,
    meta: {
      requiresAuth: true,
      admin: true,
      manager: false,
      accountant: true,
      marketer: false,
      project: true,
      operator: true
    },
    props: true
  },
];

export default reconciliationActs;



// WEBPACK FOOTER //
// ./src/router/reconciliationActs.js